import React, { Component } from 'react';
import SashiDo from 'lib/SashiDo';
import moment from 'moment';
import PhoneNumber from 'awesome-phonenumber';
import postcode from 'postcode-validator';
import { isoCountries, euCountries } from 'lib/Constants';
import * as formatter from 'lib/formatter';
import history from 'dashboard/history';
import Button from 'components/Button/Button.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import Icon from 'components/Icon/Icon.react';
import settingsStyles from 'dashboard/Settings/Settings.scss';
import stylesButton from 'components/Button/Button.scss';
import PreLoader from 'components/PreLoader/PreLoader.react';
import InlineSubmitInput from 'components/InlineSubmitInput/InlineSubmitInput.react';
import ChromeDropdown from 'components/ChromeDropdown/ChromeDropdown.react';
import Fieldset from 'components/Fieldset/Fieldset.react';
import InputField from 'components/InputField/InputField.react';
import Field from 'components/Field/Field.react';
import Label from 'components/Label/Label.react';
import { timeStampToUTC } from 'lib/DateUtils';
import Notification from 'components/Notification/Notification.react';
import AppsManager from 'lib/AppsManager';
import styles from './Billing.scss';


class UpdateBillingInfo extends Component {
  constructor(props) {
    super(props);

    this.subsection = 'Billing';

    const billingInfoState = {
      name: {
        value: null,
        valid: null,
      },
      email: {
        value: null,
        valid: null,
      },
      address: {
        value: null,
        valid: null,
      },
      phone: {
        value: null,
        valid: null,
      },
      country: {
        value: null,
        valid: null,
      },
      city: {
        value: null,
        valid: null,
      },
      state: {
        value: null,
        valid: null,
      },
      zip: {
        value: null,
        valid: null,
      },
      company_name: {
        value: null,
        valid: null,
      },
      vat_id: {
        value: null,
        valid: null,
      },
    };

    const billingAdress = props.currentCustomer.info.billing_address || {};

    billingInfoState.name.value = billingAdress.first_name ? `${billingAdress.first_name} ${billingAdress.last_name}` : '';
    billingInfoState.name.valid = !!billingInfoState.name.value;

    billingInfoState.email.value = billingAdress.email || props.currentUser.email;
    billingInfoState.email.valid = !!billingInfoState.email.value;

    billingInfoState.address.value = billingAdress.line1;
    billingInfoState.address.valid = !!billingInfoState.address.value;

    const originalPhone = props.currentCustomer.info.phone && props.currentCustomer.info.phone.startsWith('+')
      ? props.currentCustomer.info.phone
      : `+${props.currentCustomer.info.phone}`;

    const pn = new PhoneNumber(originalPhone);
    let phone = '+';

    if (pn.isValid()) {
      phone = pn.getNumber('international');
    }

    billingInfoState.phone.value = phone;
    billingInfoState.phone.valid = pn.isValid();

    billingInfoState.country.value = billingAdress.country || '';
    billingInfoState.country.valid = !!billingInfoState.country.value;
    const countries = Object.keys(isoCountries).map(value => ({ key: isoCountries[value], value }));

    billingInfoState.city.value = billingAdress.city;
    billingInfoState.city.valid = !!billingInfoState.city.value;

    billingInfoState.state.value = billingAdress.state;

    billingInfoState.zip.value = billingAdress.zip;
    billingInfoState.zip.valid = !!billingInfoState.zip.value;

    billingInfoState.company_name.value = billingAdress.company;

    billingInfoState.vat_id.value = props.currentCustomer.info.vat_number || props.currentCustomer.info.cf_company_reg_no;


    this.state = {
      loading: true,
      note: null,
      billingInfoState,
      countries,
    };
  }

  async componentDidMount() {
    const state = { loading: false };

    this.setState(state);
  }

  onCloseClick = () => {
    history.push('/billing/info');
  }

  onInputChange = (field) => {
    return (e, value, validate) => {
      this.setState((state) => {
        const { billingInfoState } = state;

        billingInfoState[field].value = value;
        billingInfoState[field].valid = validate(value);

        return {
          billingInfoState,
        };
      });
    }
  }

  onCountryChange = (country) => {
    this.setState((state) => {
      const { billingInfoState } = state;
      billingInfoState.country.value = country;
      billingInfoState.country.valid = !!country;

      const countryCode = billingInfoState.country.value;
      const zip = billingInfoState.zip.value;
      const isValid = postcode.validate(zip, countryCode);
      billingInfoState.zip.value = zip;
      billingInfoState.zip.valid = isValid;

      return {
        billingInfoState,
      };
    });
  }

  onPhoneChange = (e) => {
    const { value } = e.target;
    const newValue = value.startsWith('+') ? value : `+${value}`;

    const pn = new PhoneNumber(newValue);

    this.setState((state) => {
      const { billingInfoState } = state;
      billingInfoState.phone.value = pn.isValid() ? pn.getNumber('international') : newValue;
      billingInfoState.phone.valid = pn.isValid();

      return {
        billingInfoState,
      };
    });
  }

  onZipChange = (e) => {
    const zip = e.target.value;

    this.setState((state) => {
      const { billingInfoState } = state;
      const countryCode = billingInfoState.country.value;

      const isValid = postcode.validate(zip, countryCode);

      billingInfoState.zip.value = zip;
      billingInfoState.zip.valid = isValid;

      return {
        billingInfoState,
      };
    });
  }

  checkValidation = () => {
    const { billingInfoState } = this.state;
    const fields = ['name', 'email', 'address', 'phone', 'country', 'city', 'zip'];

    for (const i of fields) {
      if (billingInfoState[i].valid === false) {
        return true;
      }
    }

    return false;
  }

  onClickHandler = () => {
    // console.log('@@@ SAVING @@@');
  }

  renderForm = () => {
    const { billingInfoState, countries } = this.state;
    const disabled = this.checkValidation();
    const content = (
      <Fieldset
        legend="Payment Method"
        description="Enter Your Payment Information">
        <div className={settingsStyles.settingsBox}>
          <div className={[styles.box, styles.table, styles.billingInfo].join(' ')}>
            <div className={styles.tableRow}>
              <div className={styles.col1}>Billing Info</div>
            </div>

            <div className={[styles.box, styles.pa, styles.rows].join(' ')}>

              <div className={styles.row}>
                <InputField label="Full Name" require validate={[v_require]} valid={billingInfoState.name.valid} onChange={this.onInputChange('name')} value={billingInfoState.name.value} />
                <InputField label="E-mail" require validate={[v_require]} valid={billingInfoState.email.valid} onChange={this.onInputChange('email')} value={billingInfoState.email.value} />
              </div>

              <div className={styles.row}>
                <InputField label="Address" require validate={[v_require]} valid={billingInfoState.address.valid} onChange={this.onInputChange('address')} value={billingInfoState.address.value} />
                <InputField label="Phone" require validate={[v_require]} valid={billingInfoState.phone.valid} onChange={e => this.onPhoneChange(e)} value={billingInfoState.phone.value} />
              </div>

              <div className={styles.row}>
                <ChromeDropdown
                  color="blue"
                  value={billingInfoState.country.value}
                  className="select"
                  require
                  valid
                  label="Country"
                  options={countries}
                  onChange={this.onCountryChange} />

                <InputField label="City" require validate={[v_require]} valid={billingInfoState.city.valid} onChange={this.onInputChange('city')} value={billingInfoState.city.value} />
              </div>

              <div className={styles.row}>
                <InputField label="State" valid={billingInfoState.state.valid} onChange={this.onInputChange('state')} value={billingInfoState.state.value} />
                <InputField label="ZIP" require valid={billingInfoState.zip.valid} onChange={(e) => this.onZipChange(e)} value={billingInfoState.zip.value} />
                {/* <InputField label="ZIP" require valid={billingInfoState.zip.valid} onChange={this.onInputChange('zip')} value={billingInfoState.zip.value} /> */}
              </div>

              <div className={styles.row}>
                <InputField label="Company Name" require={false} valid={billingInfoState.company_name.valid} onChange={this.onInputChange('company_name')} value={billingInfoState.company_name.value} />
                <InputField label="VAT ID / Company Reg. #" require={false} pre={euCountries.includes(billingInfoState.country.value) ? billingInfoState.country.value : null} valid={billingInfoState.vat_id.valid} onChange={this.onInputChange('vat_id')} value={billingInfoState.vat_id.value} />
              </div>

              <div className={[styles.box, styles.pa].join(' ')}>
                <Button color="green" value="Save Changes" block disabled={disabled} onClick={this.onClickHandler} />
              </div>
            </div>
          </div>
        </div>
      </Fieldset>
    );

    return content;
  }

  render() {
    const classes = [settingsStyles.settings_page, settingsStyles.default];

    return (
      <div className={classes.join(' ')}>
        <Toolbar section="Billing" subsection="Update Your Billing Info">
          <Button value="Go Back" onClick={this.onCloseClick} />
        </Toolbar>
        <PreLoader loading={this.state.loading}>
          <div className={settingsStyles.holder}>
            {this.renderForm()}
          </div>
        </PreLoader>
        <Notification note={this.state.note} fullscreen={false} close />
      </div>
    );
  }
}

const v_require = (value) => {
  if (value != '') {
    return true;
  }

  return false;
}

export default UpdateBillingInfo;
